<template>
    <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">

            <!-- <v-btn icon rounded class="mx-3 white primary&#45;&#45;text" v-if="isHome && isFtpOnlyMode" @click="logout()">
                <v-icon v-text="icons.mdiLogout"></v-icon>
            </v-btn> -->

            <v-btn v-show="isHome" :class="{'bounce elevation-20': configHasUnsavedChanges()['status'], 'elevation-10': ! configHasUnsavedChanges()['status'], 'white--text darken-3 text--darken-3 grey': isDark}"
                   class="font-weight-bold bottom-right-floating"
                   color="white"
                   cols="4" rounded title="Click to save all your changes." v-bind="attrs"
                   x-large v-on="on" @click.native.prevent="configIdefix3Persist()">
                <v-progress-circular v-if="saveProgressBar" :size="18" :width="1" color="grey"
                                     indeterminate></v-progress-circular>
                <!--<v-img src="public/img/ios-spinner.png" max-width="30" v-if="!saveProgressBar"></v-img>-->
                <div v-else>
                    <v-icon
                        :color="configHasUnsavedChanges()['status'] ? 'red' : isDark ? 'primary lighten-2' : 'secondary'"
                        v-text="icons.mdiContentSaveCog"></v-icon>
                </div>

                <span class="ml-3 letter-spacing-initial text-transform-initial">{{ $gettext('Save') }}</span>

            </v-btn>

            <!--
            <v-btn icon rounded class="mx-2 white primary&#45;&#45;text">
                <v-icon v-text="icons.mdiContentSave"></v-icon>
            </v-btn>
            -->
        </template>
        <span>
            <span v-if="saveProgressBar" v-text="$gettext('Just a moment...')"></span>
            <span v-else-if="!configHasUnsavedChanges()['status']"
                  v-text="$gettext('All your changes are saved!')"></span>
            <span v-else v-text="$gettext('You have unsaved changes')"></span>
        </span>
        <snackbar ref="snackbar"></snackbar>
    </v-tooltip>
</template>
<script>

import {mapWritableState, storeToRefs} from "pinia";
import {useLoginStore} from "@/stores/LoginStore";
import MixinConfig from "@/mixins/database/MixinConfig";
import MixinIcon from "@/mixins/MixinIcon";
import {usePhonesStore} from "@/stores/PhonesStore";
import {useProgressBarsStore} from "@/stores/ProgressBarStore";
import {computed, ref} from "vue";
import MixinGenericComponent from "@/mixins/generic/MixinGenericComponent";
import MixinDark from "@/mixins/database/MixinDark";
import Snackbar from "@/components/Snackbar.vue";
import {useGeneralStore} from "@/stores/GeneralStore";
import {useAuthenticationStore} from "@/stores/AuthenticationStore";
import MixinPersonalControl from "@/mixins/MixinPersonalControl";
import {usePersonalControlsStore} from "@/stores/PersonalControlsStore";
import MixinSwalConfirmation from "@/mixins/swal/MixinSwalConfirmation";

export default {
    name: 'SaveFloatingButton',
    components: {Snackbar},
    setup() {
        let configHasUnsavedChanges = ref(MixinConfig.methods.configHasUnsavedChanges)
        let configIdefix3Persist = ref(MixinConfig.methods.configIdefix3Persist)
        const icons = MixinIcon.data().icons
        let genericComponentGetComponent = ref(MixinGenericComponent.methods.genericComponentGetComponent)
        let isDark = computed(MixinDark.computed.isDark)
        let personalControlsStore = usePersonalControlsStore()
        let allowedEdits = personalControlsStore.allowedEdits
        let alertIfEditsNotAllowed = ref(MixinPersonalControl.methods.alertIfEditsNotAllowed)
        let alertThatSaveIsNotAllowed = ref(MixinPersonalControl.methods.alertThatSaveIsNotAllowed)

        let swalConfirmation = ref(MixinSwalConfirmation.methods.swalConfirmation)
        const phonesStore = useProgressBarsStore()
        const {
            saveProgressBar
        } = storeToRefs(phonesStore);

        const generalStore = useGeneralStore()
        const {
            beforeunloadListenerTracker
        } = storeToRefs(generalStore);
        const {
            isAuthenticated
        } = storeToRefs(useAuthenticationStore());

        let isHome = computed(function () {
            return this.$route.name === 'Home'
        })

        return {
            isDark,
            configHasUnsavedChanges,
            configIdefix3Persist,
            // ...storeToRefs(useLoginStore()),
            icons,
            saveProgressBar,
            isHome,
            genericComponentGetComponent,
            beforeunloadListenerTracker,
            isAuthenticated,
            alertIfEditsNotAllowed,
            allowedEdits,
            swalConfirmation,
            alertThatSaveIsNotAllowed
        }
    }
}

</script>
<style type="text/scss">

.bottom-right-floating {
    position: fixed;
    bottom: 80px;
    right: 60px;
    z-index: 1000;
}

/**
 * Bounce animation
 * Animate once every 10 seconds
 */
.bounce {
    animation: bounce-in 10s;
    animation-iteration-count: infinite;
}

@keyframes bounce-in {
    0% {
        transform: scale(0);
        image-rendering: crisp-edges;
    }
    5% {
        transform: scale(1.8);
    }
    10% {
        transform: scale(1);
    }
    100% {
        transform: scale(1);
    }
}

.text-transform-initial {
    text-transform: initial;
}

.letter-spacing-initial {
    letter-spacing: initial;
}
</style>